<template>

</template>

<script>
export default {
name: "statistical"
}
</script>

<style scoped>

</style>